/* @flow */

import React from 'react';
import WorkbenchIcon from '../WorkbenchIcon/WorkbenchIcon';
import WorkbenchIcons from '../WorkbenchIcon/WorkbenchIcons';

type $Props = {
  loading: boolean,
  percentage?: number,
  label?: string,
  background?: 'light' | 'dark'
};

const ProgressLoader = (props: $Props) => {
  const { loading, percentage, label, background } = props;
  return loading === true ? (
    <div className={`dl-e-load ${ background || 'light' }`}>
      <div className={"wb-e-load wb-e-load-2" + (!percentage ? " wb-e-load-sm" : "")}>
        <WorkbenchIcon icon={WorkbenchIcons.ICO_LOADER_DEFAULT} modifierClass="wb-e-load-2__icon" />
        { percentage &&
          <div className="wb-e-load-2__text">{String(percentage) + "%"}</div>
        }
      </div>
      { label &&
        <div className="dl-e-load__label">
          {label}
        </div>
      }
    </div>
  ) : null;
};

export default ProgressLoader;
